import {doc} from '../docs.js';

doc(
    "uniqueAppend",
    {
        value: "",
        limit: "",
    },
    "Appends but keeping indices of elements w same id ",
    () => 1,
    {
        inlets: 2,
        connects: [
            {
                outlet: "Output 1",
                object: "sdf.manager",
                inlet: "SDF List"
            }
            ]
    });
        
export const uniqueAppend = (object, limit) => {
    let storedList = [];
    return ([msgList]) => {
        if (typeof msgList[0] !== "object") {
            msgList = [msgList];
        }
        for (let msg of msgList) {
            let index = -1;
            for (let i=0; i < storedList.length; i++) {
                if (msg.id === storedList[i].id) {
                    index = i;
                }
            }
            if (index === -1 && storedList.length < (limit() || 1)) {
                storedList.push(msg);
            } else {
                storedList[index] = msg;
            }
            
            if (storedList.length > (limit() || 1)) {
                storedList.shift();
            }
        }

        if (storedList.length === (limit() || 1)) {
            return [storedList];
        }
    };
};
